import * as React from 'react'

import { cn } from '../lib/utils'

export interface TruncationNoticeProps {
  /** Aantal geladen rijen (data.length). */
  geladen: number
  /** Servertotaal (meta.total) van de volledige gefilterde set. */
  totaal: number
  /** Meervoudsnaam van het item, bv. "documenten" of "weekstaten". */
  itemLabel?: string
  /** Extra hint achter de melding; default verwijst naar de filters. */
  hint?: string
  /**
   * Volledige, al vertaalde melding i.p.v. de NL-standaardzin (batch-65: de
   * tweetalige klant-app, next-intl). Het tonen blijft aan `geladen`/`totaal` gekoppeld.
   */
  melding?: string
  className?: string
}

/**
 * Zichtbaar vangnet voor afgekapte lijsten (limit-cap-audit): een fetch-all
 * met een cap mag nooit stil afkappen. Rendert niets zolang alles geladen is;
 * daarboven de amber "Eerste N van M"-melding die de fetch-all-overzichten
 * hand-gerold gebruiken. Nieuwe lijsten gebruiken dít component i.p.v. een
 * eigen banner.
 */
export function TruncationNotice({
  geladen,
  totaal,
  itemLabel = 'rijen',
  hint = 'Verfijn met de filters om de rest te zien.',
  melding,
  className,
}: TruncationNoticeProps) {
  if (totaal <= geladen) return null
  return (
    <p
      role="status"
      className={cn(
        'rounded-md border border-amber-300 bg-amber-50 px-3 py-2 text-xs text-amber-800',
        className,
      )}
    >
      {melding ?? `Eerste ${geladen} van ${totaal} ${itemLabel} getoond. ${hint}`}
    </p>
  )
}
